import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReasonsDelayComponent } from './reasons-delay/reasons-delay.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ReasonsDelayService} from '../../../core/services/reasons-delay.service';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [
    ReasonsDelayComponent
  ],
  declarations: [ReasonsDelayComponent],
  providers: [ReasonsDelayService]
})
export class ReasonsDelayModule { }



// WEBPACK FOOTER //
// ./src/app/pages/trip-reservations/reasons-delay/reasons-delay.module.ts